import { Component, Input, OnInit } from '@angular/core';
import { Customer } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';
import { BmsMeterExchangesImportResult } from '@features/bms/models/bms-meter-exchanges-import-result';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-bms-meter-exchange-admin',
  templateUrl: './bms-meter-exchange-admin.component.html',
  styleUrls: ['./bms-meter-exchange-admin.component.scss']
})
export class BmsMeterExchangeAdminComponent implements OnInit {

  @Input() customer : Customer;
  @Input() meterExchangesImportResult : BmsMeterExchangesImportResult;

  constructor() { }

  ngOnInit() {
  }

  async export() {
    var headers: string[] = ['oldMeterInfo', 'newMeterInfo', 'exchangeDateString', 'startValue', 'endValue', 'ok', 'message'];
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.meterExchangesImportResult.meterExchanges, { header: headers });

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    XLSX.writeFile(wb, 'MeterExchanges ' + this.customer.name + '.xlsx');
  }
}
